import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { BaseNavigationProps } from '../../navigation/_root'
import {
  ATLButton,
  ATLSingleImage,
  ATLSpacing,
  ATLTextHead,
  ButtonTypeEnum,
  FontWeightEnum,
  ImagePickerTypeEnum,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../atlTheme'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { images } from '../../constants/searchAssets'
import styled from 'styled-components/native'
import { ScrollView } from 'react-native'
import { FeatureManager } from '../../FeatureManager'

const FirstLoginContainer = styled.SafeAreaView`
  background-color: ${atlTheme.ColorSurface};
  display: flex;
  height: 100%;
`
const CoverContainer = styled.View`
  top: ${atlTheme.SpacingWide}px;
`
const MessageContainer = styled.View`
  width: 100%;
  margin-top: ${atlTheme.SpacingDistribute}px;
  margin-left: ${atlTheme.SpacingMarginal}px;
  padding-right: ${atlTheme.SpacingMarginal}px;
`
const MessageTextBody = styled.Text`
  font-family: ${atlTheme.FontFamilySystem};
  font-style: normal;
  font-weight: normal;
  font-size: ${atlTheme.FontSizeBody};
  line-height: ${atlTheme.LineHeightBase};
  color: ${atlTheme.ColorHighContrast};
  flex: none;
  margin: 0px 0px;
  display: flex;
  align-items: flex-end;
`

export const FirstLoginScreen: NavigationStackScreenComponent<BaseNavigationProps> = () => {
  const onPressHandleNextScreen = () => {
    return FeatureManager.isOnboardingEnabled ? Coordinator.goToOnboarding : Coordinator.goToMainScreen
  }

  return (
    <FirstLoginContainer>
      <ScrollView style={{ flex: 1, height: '100%' }}>
        <CoverContainer>
          <ATLSingleImage source={images.firstLoginCover} type={ImagePickerTypeEnum.wide} />
        </CoverContainer>
        <ATLSpacing type={SpacingSizesEnum.distribute} />
        <MessageContainer>
          <ATLTextHead
            textAlignment={TextAlignmentEnum.left}
            labelBaseProps={{
              fontSize: atlTheme.FontSizeDisplay,
              fontWeight: FontWeightEnum.normal,
              lineHeight: atlTheme.LineHeightDisplay,
            }}
            horizontalMargin={1}
          >
            {formatMessage(messages.firstLoginScreen_headTitle)}
          </ATLTextHead>
          <MessageTextBody>{formatMessage(messages.firstLoginScreen_subTitle)}</MessageTextBody>
          <ATLSpacing type={SpacingSizesEnum.marginal} />
        </MessageContainer>
        <ATLSpacing type={SpacingSizesEnum.distribute} />
        <ATLButton
          type={ButtonTypeEnum.default}
          title={formatMessage(messages.firstLoginScreen_changePasswordButtonTitle)}
          buttonBaseProps={{
            borderRadius: atlTheme.BorderRadius100,
          }}
          onPress={Coordinator.goToRedefinePassword}
        />
        <ATLSpacing type={SpacingSizesEnum.marginal} />
        {FeatureManager.isChangeNameLaterEnabled && (
          <ATLButton
            type={ButtonTypeEnum.label}
            title={formatMessage(messages.firstLoginScreen_changeLaterButtonTitle)}
            onPress={onPressHandleNextScreen}
            buttonBaseProps={{
              borderRadius: atlTheme.BorderRadius100,
              textColorComplementary: atlTheme.ColorBrand2Default,
            }}
          />
        )}
      </ScrollView>
    </FirstLoginContainer>
  )
}
FirstLoginScreen.navigationOptions = {
  headerShown: false,
}
